//
// itkModulesPath is the path that contains the directories
//
// - WebWorkers/
// - ImageIOs/
// - MeshIOs/
//
var itkConfig = {
  itkModulesPath: 'itk'
};
export default itkConfig;